<template>
    <div class="search_form">
        <app-text 
            :label="label"
            v-model="value"
            :placeholder="placeholder"
            class="search_form_text"
            @input="dataInput"
            @change="dataChange"
            @keydown-enter="onclick"
        />
        <app-button
            :value="buttonName"
            @button-click="onclick"
            this-class="btn_search"
        />
    </div>
</template>

<script>
/**
 * 検索フォーム
 * 
 * [プロパティ]
 * label ... 検索フォームの左に表示するラベル
 * value ... v-modelの値。dataにコピーしてテキストボックスに受け渡す
 * buttonName ... ボタンに表示する文字
 * placeholder ... プレースホルダとしてテキストボックスに表示する文言
 * 
 * [イベント処理]
 * クリック時 ... this.$emit('click', event)
 * 入力時 ... this.$emit('input', event)
 * 
 * [利用例]
 * <search-button
 *     v-model="searchPefcText"
 *     id="cogen_pefc_filter"
 *     label="メーカ名、品番等の一部"
 *     placeholder=""
 *     button-name="検索"
 *     class="str15em align_left"
 *     @click="searchPefcCogenItem"
 *     key="pefc"
 * />
 * 
 * [データ]
 * searchText ... v-modelの値をコピーしたもの。テキストボックスに受け渡す
 */

import AppText from '@/components/atoms/AppText.vue'
import AppButton from '@/components/atoms/AppButton.vue'

export default {
    name:"SearchButton",
    components:{AppText, AppButton},
    props:{
        label:String,
        value: {
            type: [String, Number],
            required: false
        },
        buttonName:String,
        placeholder: String,
    },
    methods:{
        onclick(event){
            this.$emit('click', event)
        },
        dataInput(event){
            this.$emit('input', event)
        },
        dataChange(event){
            this.$emit('change', event)
        }
    }
}
</script>

<style scoped>
.search_form{
    display: flex;
    align-items: center;
    width: auto;
    margin: 0 auto 1rem;
}
.align_left.search_form{
    margin: 0 auto 1em 0;
}
.search_form >>> .search_form_text{
    display: flex;
    align-items: center;
    margin: 0;
}
.search_form >>> label{
    white-space: nowrap;
}
.search_form >>> input[type="text"],
.search_form >>> input[type="number"]{
    box-sizing: border-box;
    width: auto;
    min-width: 10em;
    height: 36px;
    margin: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    outline: none;
}
.search_form >>> input[type="button"]{
    height: 36px;
    margin: 0 0 0 -9px;
    white-space: nowrap;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
/* 検索ウインドウの入力幅を指定 */
.str10em.search_form{
    width: auto;
}
.str10em.search_form >>> input[type="text"],
.str10em.search_form >>> input[type="number"]{
    width: 10em;
}
.str20em.search_form{
    width: auto;
}
.str15em.search_form >>> input[type="text"],
.str15em.search_form >>> input[type="number"]{
    width: 15em;
}
.str20em.search_form >>> input[type="text"],
.str20em.search_form >>> input[type="number"]{
    width: 20em;
}
.str30em.search_form{
    width: auto;
}
.str30em.search_form >>> input[type="text"],
.str30em.search_form >>> input[type="number"]{
    width: 30em;
}
.wd95per.search_form .input_container{
    width: 100%;
}
.wd95per.search_form .input_container >>> .rowcontents{
    width: 100%;
}
.wd95per.search_form .input_container >>> .rowcontents input{
    width: 100%;
}

/* 角丸＋虫眼鏡アイコン。主に一覧画面ですでに表示されているテーブルから検索する場合に使ってください */
.round >>> input[type="text"],
.round >>> input[type="number"]{
    height: 32px;
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
    padding-left: 16px; 
}
.round >>> button{
    width: 45px;
    height: 32px;
    padding: 0;
    background: url(/img/icon_set_ol.png);
    background-size: auto 500%;
    background-position-x: 96%;
    background-position-y: 35%;
    color: transparent;
    background-color: #aaa;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;

}
p > span {
  font-size: 18px;
  line-height: 18px;
  font-weight: bolder;
}
</style>